import React, { useState } from 'react';
import ButtonComp from 'atoms/Buttons/Presentation/ButtonComp';
import { useSelector } from 'react-redux';
import { CART_PAGE_CONSTANTS } from 'organisms/CartPage/Constants/CartPageConstants';
import RemoveGiftCardModal from 'organisms/CartPage/AU/Presentation/ReusableComponents/RemoveGiftCardModal';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
export const removeCouponHandler = ({ setCartItem, item, setCouponModal, setQuantityActionData, quantityAction }) => {
  setCouponModal(true);
  setCartItem(item);
  setQuantityActionData(quantityAction);
};
export const quantityModifierOnClickHandler = ({
  paymentDiscountAmounts,
  setCartItem,
  item,
  setCouponModal,
  setQuantityActionData,
  quantityAction,
  event,
  updateItemQuantity,
}) => {
  paymentDiscountAmounts?.length
    ? removeCouponHandler({
        setCartItem,
        item,
        setCouponModal,
        setQuantityActionData,
        quantityAction,
      })
    : updateItemQuantity(item, quantityAction, event);
};
const QuantityModifier = props => {
  const {
    itemQuantity,
    itemCount,
    updateItemQuantity,
    quantityAction,
    item,
    itemName,
    cartItemCount,
    maxItemCountPerLineItem,
    hideChild = false,
    type = '',
    paymentDiscountAmounts = [],
  } = props;
  const { QUANTITY_INCREASE_DECREASE } = CART_PAGE_CONSTANTS;
  var dname = `${translateWithI18Next(TRANSLATE_MAPPING_KEY.DECREASE_QUANTITY_BY)} ${itemName}`;
  var iname = `${translateWithI18Next(TRANSLATE_MAPPING_KEY.INCREASE_QUANTITY_BY)}  ${itemName}`;
  const isUpdateQuantityLoading = useSelector(data => data.cartReducer?.isUpdateQuantityLoading);
  const [couponModal, setCouponModal] = useState(false);
  const [cartItem, setCartItem] = useState({});
  const [quantityActionData, setQuantityActionData] = useState('');
  return (
    <div className='cart-food-quantity-change'>
      {itemCount === itemQuantity ? (
        <ButtonComp className='button quantity-decrease' disabled data-testid='quantity-minus' ariaLable='minus'>
          {!hideChild && <span>-</span>}
        </ButtonComp>
      ) : (
        <ButtonComp
          className='button quantity-decrease'
          ariaLable={dname}
          disabled={isUpdateQuantityLoading}
          onClickHandler={event =>
            quantityModifierOnClickHandler({
              paymentDiscountAmounts,
              setCartItem,
              item,
              setCouponModal,
              setQuantityActionData,
              quantityAction: quantityAction.Decrease,
              event,
              updateItemQuantity,
            })
          }
          data-testid='quantity-minus'
          type={type}
        >
          {!hideChild && <span>-</span>}
        </ButtonComp>
      )}
      <span className='cart-food-quantity'>{itemCount}</span>
      <span className='sr-only' role='alert'>{`Quantity updated to ${itemCount}`}</span>
      <ButtonComp
        className='.transparent-btn button quantity-increase'
        ariaLable={iname}
        data-testid='quantity-plus'
        type={type}
        onClickHandler={event =>
          quantityModifierOnClickHandler({
            paymentDiscountAmounts,
            setCartItem,
            item,
            setCouponModal,
            setQuantityActionData,
            quantityAction: quantityAction.Increase,
            event,
            updateItemQuantity,
          })
        }
        disabled={
          maxItemCountPerLineItem !== 0 && cartItemCount + itemCount > maxItemCountPerLineItem
            ? true
            : false || isUpdateQuantityLoading
        }
      >
        {!hideChild && <span>+</span>}
      </ButtonComp>
      {couponModal && (
        <RemoveGiftCardModal
          cartItem={cartItem}
          setCouponModal={setCouponModal}
          quantityAction={quantityActionData}
          updateItemQuantity={updateItemQuantity}
          flag={QUANTITY_INCREASE_DECREASE}
        />
      )}
    </div>
  );
};
export default QuantityModifier;
